module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardColor
  }, [(_vm.title) ? _c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.cardIcon
    }]
  }, [_c('span', [(_vm.cardIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.cardIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "bar-color": _vm.barColor,
      "chart-data": _vm.chartData,
      "chart-height": _vm.chartHeight,
      "chart-type": _vm.chartType,
      "label-prefix": _vm.labelPrefix,
      "legend-color": _vm.legendColor,
      "legend-link": _vm.legendLink,
      "show-legend": _vm.showLegend,
      "stacked": _vm.stacked,
      "x-max-axes-rotation": _vm.xMaxAxesRotation,
      "x-min-axes-rotation": _vm.xMinAxesRotation
    }
  }), _vm._v(" "), (_vm.json.amounts && _vm.json.amounts.length) ? _c('table', {
    class: _vm.tableColor
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Count")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.chartData), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.percent).toLocaleString('en-US', {
      maximumFractionDigits: 2
    })) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.amount).toLocaleString('en-US')))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "highlight",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(Number(_vm.json.total).toLocaleString('en-US')))])]), _vm._v(" "), (_vm.noDataAvailable) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No data available")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(_vm.noDataAvailable.amount).toLocaleString('en-US')))])]) : _vm._e()])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d489df8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/barCharts/BarChartWithTable.vue
// module id = 449
// module chunks = 1